import {
  useFormErrorNotification,
  useFormSuccessNotification,
} from "@babackapp/react-hook-forms-components/form-notifications";
import { useMutation } from "@tanstack/react-query";
import { $api } from "../generated/client";
import useInvalidateShop from "./use-invalidate-shop";
import { useInvalidateWorkflowListQuery } from "./use-workflows-query";

export default function useDeleteWorkflow(shopId: string) {
  const successNotification = useFormSuccessNotification();
  const errorNotification = useFormErrorNotification();
  const invalidateShop = useInvalidateShop(shopId);
  const invalidateWorkflowListQuery = useInvalidateWorkflowListQuery(shopId);

  const mutation = $api.useMutation("delete", "/shops/{shopId}/workflows/{workflowId}");

  return useMutation({
    onSuccess: () => {
      invalidateShop();
      invalidateWorkflowListQuery();
      successNotification();
    },
    onError: () => {
      errorNotification();
    },
    mutationFn: async (workflowId: string) => {
      return mutation.mutateAsync({ params: { path: { shopId, workflowId } } });
    },
  });
}
